import React from 'react';
import { motion } from 'framer-motion';
export function RitualSection() {
  const steps = [{
    num: '10',
    unit: 'Respiraciones',
    desc: 'Bajas el volumen del cuerpo y sales de la alerta roja.',
    delay: 0
  }, {
    num: '10',
    unit: 'Líneas',
    desc: 'Sacas el bucle de tu cabeza y lo pones en papel (sin hundirte).',
    delay: 0.2
  }, {
    num: '10',
    unit: 'Preguntas',
    desc: 'Cierras el día con estructura, no con juicio.',
    delay: 0.4
  }];
  return <section className="py-24 px-6 bg-[#111827]" data-id="element-179">
      <div className="max-w-4xl mx-auto" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#f5efe3]" data-id="element-182">
            El mecanismo único: <br data-id="element-183" />
            <span className="text-[#c9956b]" data-id="element-184">Ritual 10-10-10</span>
          </h2>
          <p className="text-[#8b9bb4]" data-id="element-185">
            Siempre el mismo orden. Siempre el mismo tiempo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-186">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: step.delay,
          duration: 0.6
        }} className="relative group" data-id="element-187">
              <div className="absolute inset-0 bg-[#c9956b] opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-500" data-id="element-188" />

              <div className="bg-[#0c1220] p-8 rounded-2xl border border-white/5 h-full text-center relative z-10 hover:border-[#c9956b]/30 transition-colors" data-id="element-189">
                <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: index
            }} className="text-6xl font-bold text-[#c9956b] mb-2 font-serif" data-id="element-190">
                  {step.num}
                </motion.div>
                <h3 className="text-xl font-bold text-[#f0e6d3] mb-4 uppercase tracking-wider" data-id="element-191">
                  {step.unit}
                </h3>
                <p className="text-[#8b9bb4] leading-relaxed" data-id="element-192">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-16 text-center max-w-2xl mx-auto" data-id="element-193">
          <p className="text-xl font-serif italic text-[#f0e6d3]" data-id="element-194">
            "Porque tu mente no negocia con palabras… <br data-id="element-195" />
            negocia con{' '}
            <span className="text-[#c9956b] underline decoration-[#c9956b]/30 underline-offset-4" data-id="element-196">
              rituales
            </span>
            ."
          </p>
        </motion.div>
      </div>
    </section>;
}